<template>
  <v-layout justify-center="" style="margin-top: 10%;">
    <v-card :elevation="20" width="500" v-bind:loading="loading">
      <v-card-text class="text-center">
        <h1 class="font-weight-light">Login to CSC Self Service Portal</h1>
      </v-card-text>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 v-if="!sent">
                <v-text-field
                  v-model="username"
                  type="text"
                  name="username"
                  label="Username"
                  outlined
                  @keyup.enter.native="resetPassword"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 v-if="sent">
                <v-text-field
                  v-model="code"
                  type="text"
                  name="code"
                  label="Code"
                  outlined
                  @keyup.enter.native="resetPassword"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 v-if="sent">
                <v-text-field
                  v-model="password"
                  :type="'password'"
                  name="new-password"
                  label="New Password"
                  required
                  outlined
                  @keyup.enter.native="resetPassword"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 v-if="sent">
                <v-text-field
                  v-model="confirmPassword"
                  :type="'password'"
                  name="confirm-password"
                  label="Confirm Password"
                  required
                  outlined
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                {{ error }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!sent"
            color="orange"
            @click="submit"
            x-large
            v-bind:loading="loading"
            >Send Code
          </v-btn>
          <v-btn
            v-if="sent"
            color="orange"
            @click="verify"
            x-large
            v-bind:loading="loading"
            >Reset Password
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
      <v-card-text v-if="!sent">
        <a v-if="!sent" v-on:click="signIn">Back to Sign In</a>
      </v-card-text>
      <v-card-text v-if="sent">
        <a v-if="sent" v-on:click="submit">Resend Code</a>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import AuthEventBus from '../events/authEventBus'
import { Auth } from 'aws-amplify'

export default {
  name: 'ForgotPassword',
  props: ['forgotPasswordConfig', 'requirePasswordReset'],
  data() {
    return {
      code: '',
      password: '',
      confirmPassword: '',
      error: '',
      sent: this.requirePasswordReset,
      loading: false,
      username: ''
    }
  },
  methods: {
    submit: function() {
      Auth.forgotPassword(this.username)
        .then(() => {
          this.sent = true
        })
        .catch(e => this.setError(e))
    },
    verify: function() {
      if (this.password !== this.confirmPassword) {
        this.error = 'Passwords do not match!'
        return
      }
      Auth.forgotPasswordSubmit(this.username, this.code, this.password)
        .then(() => {
          AuthEventBus.$emit('authState', 'signIn')
        })
        .catch(e => this.setError(e))
    },
    signIn: function() {
      AuthEventBus.$emit('authState', 'signIn')
    },
    setError: function(e) {
      this.error = e.message
    }
  }
}
</script>
